// TODO (jacob): Combine this with error handler mixin
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ErrorDialogComponent } from './error-dialog.component';

@Injectable()
export class ErrorDialogService {
    constructor(private dialog: MatDialog) {}

    public open(title: string, message: string): Observable<boolean> {
        let dialogRef: MatDialogRef<ErrorDialogComponent>;

        dialogRef = this.dialog.open(ErrorDialogComponent);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;

        return dialogRef.afterClosed();
    }
}
